export default "__VITE_ASSET__DnNE4rfY__"